import { dataSmileyStar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSmileyStar = /*#__PURE__*/createIcon(dataSmileyStar)
export default IconSmileyStar
